import { BaseModal } from './BaseModal'
import { SettingsToggle } from './SettingsToggle'
import { ButtonToggle } from './ButtonToggle'
import { AcademicCapIcon } from '@heroicons/react/outline'
import {
  HARD_MODE_DESCRIPTION,
  HIGH_CONTRAST_MODE_DESCRIPTION,
  EXPERT_MODE_DESCRIPTION,
  REVEAL_SPEED_DESCRIPTION,
  BUILD_ID,
  REVEAL_SPEED_FAST,
  REVEAL_SPEED_SLOW,
  CURSOR_TYPE_DESCRIPTION,
  CURSOR_TYPE_NORMAL,
  CURSOR_TYPE_MULTI,
  HINTS_DESCRIPTION,
} from '../../constants/strings'
import { useNavigate } from 'react-router-dom'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHardMode: boolean
  handleHardMode: Function
  isExpertMode: boolean
  handleExpertMode: Function
  isDarkMode: boolean
  handleDarkMode: Function
  isHighContrastMode: boolean
  handleHighContrastMode: Function
  revealSpeed: string
  handleRevealSpeed: Function
  cursorType: string
  handleCursorType: Function
  enableHints: boolean
  handleHints: Function
}

export const SettingsModal = ({
  isOpen,
  handleClose,
  isHardMode,
  handleHardMode,
  isExpertMode,
  handleExpertMode,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
  revealSpeed,
  handleRevealSpeed,
  cursorType,
  handleCursorType,
  enableHints,
  handleHints
}: Props) => {

  const navigate = useNavigate()
  const openTips = () => {
    handleClose()
    navigate('/tips')
  }

  return (
    <BaseModal title="Settings" isOpen={isOpen} handleClose={handleClose}>
      <div className="flex flex-col mt-2 divide-y">
        <SettingsToggle
          settingName="Hard Mode"
          flag={isHardMode}
          handleFlag={handleHardMode}
          description={HARD_MODE_DESCRIPTION}
          id="settings-hard-mode"
        />
        <SettingsToggle
          settingName="Expert Mode"
          flag={isExpertMode}
          handleFlag={handleExpertMode}
          description={EXPERT_MODE_DESCRIPTION}
          id="settings-expert-mode"
        />
        <SettingsToggle
          settingName="Dark Mode"
          flag={isDarkMode}
          handleFlag={handleDarkMode}
          id="settings-dark-mode"
        />
        <SettingsToggle
          settingName="High Contrast Mode"
          flag={isHighContrastMode}
          handleFlag={handleHighContrastMode}
          description={HIGH_CONTRAST_MODE_DESCRIPTION}
          id="settings-highcontrast-mode"
        />
        <SettingsToggle
          settingName="Show hints"
          flag={enableHints}
          handleFlag={handleHints}
          description={HINTS_DESCRIPTION}
          id="settings-hints"
        />
        <ButtonToggle
          settingName="Reveal speed"
          description={REVEAL_SPEED_DESCRIPTION}
          selected={revealSpeed}
          flagValues={[REVEAL_SPEED_SLOW, REVEAL_SPEED_FAST]}
          handleFlag={handleRevealSpeed}
          id="settings-reveal-speed"
          />
        <ButtonToggle
          settingName="Cursor type"
          description={CURSOR_TYPE_DESCRIPTION}
          selected={cursorType}
          flagValues={[CURSOR_TYPE_NORMAL, CURSOR_TYPE_MULTI]}
          handleFlag={handleCursorType}
          id="settings-cursor-type"
          />
      </div>
      <div className="flex justify-between mt-4 py-2 items-center text-sm">
        <p className="text-gray-500 dark:text-gray-300 text-left">Feedback</p>
        <a href="mailto:grant.warman+polygonle@gmail.com" target="_blank" rel="noreferrer"
           className="text-indigo-700 dark:text-indigo-400 font-bold">Email</a>
      </div>
      <div className="flex flex-col justify-center items-center p-2">
      <div className="italic text-gray-500 dark:text-gray-300"> Learn more about these settings</div>
      <button
        onClick={openTips}
        className="text-gray-900 mt-2 text-white group flex w-64 items-center rounded-md px-4 py-2 title text-lg justify-center items-center text-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm row-span-1">
        <AcademicCapIcon 
          className="h-6 w-6 mr-2 scale-up cursor-pointer stroke-white"
          aria-label={'tips'}
          role="button"
          tabIndex={0}
        />
        <div className="text-sm text-white">Tips & Tricks</div>
      </button>
    </div>
      <div className="text-xs text-right mt-4 text-gray-400 dark:text-gray-500">build id: {BUILD_ID}</div>
    </BaseModal>
  )
}
